<div class="delivery-all-entrepreneurs-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="allEntrepreneurs()"></grid-content>
</div>